module.exports = __webpack_public_path__ + "img/beijingluwenhualvyouqu.b367504c.png";